export default [
  {
    path: '/app/carousel',
    name: 'Carousel',
    component: () => import('@/views/Carousel/Index.vue'),
    meta: {
      pageTitle: 'Slide Görseller',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'CAROUSEL_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/carousel/add',
    name: 'CarouselAdd',
    component: () => import('@/views/Carousel/Add.vue'),
    meta: {
      pageTitle: 'Slide Görseller',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/carousel',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'CAROUSEL_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/carousel/edit/:id',
    name: 'CarouselEdit',
    component: () => import('@/views/Carousel/Edit.vue'),
    meta: {
      pageTitle: 'Slide Görseller',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/carousel',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'CAROUSEL_EDIT',
      action: 'read',
    },
  },
]
